import React from 'react'
import { WebinarAvatars } from '../avatars/avatars'
import { CTALink } from 'marketing-site/src/library/elements/CTALink'
import { CTATheme } from 'marketing-site/src/library/utils'
import { IWebinar } from 'marketing-site/src/components/bespoke/webinars'
import { ImageOrAutoplayVideo } from 'marketing-site/src/library/elements/ImageOrAutoplayVideo'
import { Text } from 'marketing-site/src/library/elements/Text'
import useTranslate from 'marketing-site/src/library/hooks/useTranslate'

interface IWebinarsCategory {
  category?: string
  webinars: IWebinar[]
}

export function RecordedWebinarsCategory({ category, webinars }: IWebinarsCategory) {
  const { translate } = useTranslate()
  return (
    <div className="recorded-webinars__category">
      {category && (
        <h2 className="recorded-webinars__category__title">
          <Text brand="default" size="heading-4-bold">
            {category}
          </Text>
        </h2>
      )}
      <div className="recorded-webinars__list">
        {webinars.map((webinar, index) => (
          <div className="recorded-webinar" key={index}>
            <a href={webinar.url} className="recorded-webinar__thumbnail">
              <WebinarAvatars speakers={webinar.speakers} />
              <ImageOrAutoplayVideo
                imageRef={{
                  ...webinar.thumbnailImage,
                  altText: webinar.title,
                }}
              />
              <div className="recorded-webinar__duration">{`${webinar.duration}${translate(
                'min',
              )}`}</div>
            </a>
            <p className="recorded-webinar__description">
              <Text brand="default" size="body">
                {webinar.subtitle}
              </Text>
            </p>
            <CTALink
              url={webinar.url}
              text="Watch now"
              small={true}
              arrow={true}
              bgColor={CTATheme.LinkOnlyBlack}
            />
          </div>
        ))}
      </div>
    </div>
  )
}
